import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { knowledgebaseService } from '../Services/knowledgebaseService';
import useGlobals from './useGlobals';
import { setModal } from '../Store/Actions/modalActions';
import toast from 'react-hot-toast';
import { PaginationListType } from '../Types/PaginationParams';
import { setListReloadType } from '../Store/Actions/environmentActions';

const useKnowledgebases = () => {
    const navigate = useNavigate();
    const { i18n, dispatch, windowWidth, getBreakpoint } = useGlobals();

    const handleNavigate = useCallback(
        (id?: string) => {
            navigate(id ? `/admin/knowledgebases/${id}` : '/admin/knowledgebases/new');
        },
        [navigate],
    );

    const handleDelete = useCallback(
        async (id: string) => {
            try {
                await knowledgebaseService.deleteKnowledgebase(id);
                dispatch(setModal({ state: 'closed' }));
                dispatch(setListReloadType(PaginationListType.Knowledgebases));

                toast.success(i18n.translate({ id: 'delete.success', sourceName: 'Knowledgebases' }));
            } catch (error) {
                console.error('Error deleting knowledgebase:', error);
                toast.error(i18n.translate({ id: 'delete.error', sourceName: 'Knowledgebases' }));
            }
        },
        [dispatch, i18n],
    );

    const handleOpenConfirmDialog = useCallback(
        (id: string) => {
            dispatch(
                setModal({
                    state: 'open',
                    title: i18n.translate({ id: 'delete.title', sourceName: 'Knowledgebases' }),
                    content: i18n.translate({ id: 'delete.text', sourceName: 'Knowledgebases' }),
                    buttonRightText: i18n.translate({ id: 'delete.button', sourceName: 'Knowledgebases' }),
                    buttonRightAction: () => handleDelete(id),
                    buttonLeftText: i18n.translate({ id: 'delete.cancel', sourceName: 'Knowledgebases' }),
                    buttonLeftAction: () => dispatch(setModal({ state: 'closed' })),
                    modalSize: 'medium',
                    closeOnAction: true,
                    showCloseButton: true,
                    closeFunction: () => dispatch(setModal({ state: 'closed' })),
                }),
            );
        },
        [dispatch, handleDelete, i18n],
    );

    const KnowledgebasesActions = {
        handleDelete,
        handleOpenConfirmDialog,
    };

    return {
        KnowledgebasesActions,
        handleNavigate,
        i18n,
        windowWidth,
        getBreakpoint,
    };
};

export default useKnowledgebases;
